import { namespace } from 'format-message';

// Use format-message namespace to avoid interfering with SDK consuming apps
export var t = namespace();
export default t;